import {HttpModelConverter} from '../../../../../../../../core/converter/httpModel.converter';
import {SaleInvoiceConfigurationModel} from '../saleInvoiceConfiguration.model';
import {
    LovValueSummaryConverter
} from '../../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {
    CommunicationConfigurationEmailConverter
} from "../../../../../../../../communication/configuration/email/common/api/model/converter/communicationConfigurationEmail.converter";
import {SaleInvoiceConfigurationBookConverter} from "./saleInvoiceConfigurationBook.converter";

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceConfigurationConverter extends HttpModelConverter<SaleInvoiceConfigurationModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private emailConfigurationConverter: CommunicationConfigurationEmailConverter,
                private bookConverter: SaleInvoiceConfigurationBookConverter) {
        super();
    }

    protected createInstance(): SaleInvoiceConfigurationModel {
        return new SaleInvoiceConfigurationModel();
    }

    protected enrichObject(result: SaleInvoiceConfigurationModel, src: SaleInvoiceConfigurationModel) {
        result.invoiceType = this.lovValueSummaryConverter.convert(src.invoiceType);
        result.emailConfiguration = this.emailConfigurationConverter.convert(src.emailConfiguration);
        result.purchaseOrderEmailConfiguration = this.emailConfigurationConverter.convert(src.purchaseOrderEmailConfiguration);
        result.books = this.bookConverter.convertFromArray(result.books);
    }
}
